var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
import OrderService from '../../api/OrderService';
import { EPurOrderStatus } from "../../enum/EStatus";
import { EBillType } from "../../enum/EBillType";
import BillSubTable from "../../components/bill/BillSubTable.vue";
var PurOrderTable = (function (_super) {
    __extends(PurOrderTable, _super);
    function PurOrderTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.eBillType = EBillType;
        _this.splitStatusMap = {
            yes: 1,
            no: 0
        };
        _this.thirdPartyStatus = true;
        _this.dialogVisible = false;
        _this.dialogTableData = Array;
        _this.isDelivery = false;
        _this.purOrderStatus = EPurOrderStatus;
        _this.refresh = true;
        return _this;
    }
    Object.defineProperty(PurOrderTable.prototype, "Columns", {
        get: function () {
            console.log(this.isDelivery);
            var start = [], end = [], cols = [];
            var tempStr = "发货量";
            if (this.isDelivery) {
                tempStr = "送货量";
            }
            var center = [
                { prop: "supplier_goods_code", label: "货品编码", sortable: false, minWidth: "80", toPageType: false },
                { prop: "goods_format_name", label: "规格", minWidth: "180", sortable: false, toPageType: false },
                { prop: "goods_name", label: "客户货品名称", sortable: true, width: "180", toPageType: false },
                { prop: "goods_code", label: "客户货品编码", sortable: false, width: "180", toPageType: false },
                { prop: "goods_format", label: "客户货品规格", sortable: false, width: "180", toPageType: false },
                { prop: "sales_unit_name", label: "单位", sortable: false, width: "80", toPageType: false },
                { prop: "order_detail_amount", label: "采购量", sortable: true, width: "100", toPageType: false },
                { prop: "supplier_goods_id", label: tempStr, sortable: false, width: "80", toPageType: false },
            ];
            switch (this.status) {
                case "1":
                    center.unshift({ prop: "shop_name", label: "订货门店", align: 'left', sortable: false, width: "150", toPageType: false }, { prop: "supplier_goods_name", label: "货品名称", sortable: false, width: "150", toPageType: false });
                    break;
                case "2":
                    center.unshift({ prop: "supplier_goods_name", label: "货品名称", sortable: false, width: "150", toPageType: false }, { prop: "shop_name", label: "订货门店", align: 'left', sortable: false, width: "150", toPageType: false });
                    break;
                case "3":
                    center.unshift({ prop: "supplier_goods_name", label: "货品名称", sortable: false, width: "300", toPageType: false }, { prop: "", label: "", sortable: false, width: "", toPageType: false });
                    break;
            }
            cols = start.concat(center).concat(end);
            return cols;
        },
        enumerable: true,
        configurable: true
    });
    PurOrderTable.prototype.created = function () {
        this.service = OrderService.getInstance();
    };
    PurOrderTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 280;
        }, 300);
    };
    PurOrderTable.prototype.showShippedCodeDialog = function (data, toPageType) {
        this.dialogVisible = true;
        this.dialogTableData = data;
        this.dialogTableData.forEach(function (item, index) {
            item["index"] = index + 1;
            item["toPageType"] = toPageType;
            item["label"] = toPageType == 2 ? "入库单号" : "送货单号";
            item["datail"] = toPageType == 2 ? item.warehouse_receipt_code : item.delivery_order_code;
        });
    };
    PurOrderTable.prototype.previewSourceCode = function (row) {
        this.$emit('previewSourceCode', row);
    };
    PurOrderTable.prototype.saveSingle = function (row, type) {
        var _this = this;
        var timer = setTimeout(function () {
            clearTimeout(timer);
            _this.listData.forEach(function (item) {
                if (item.index == row.index) {
                    item.printNum = row.printNum;
                }
            });
            console.log(_this.listData);
        }, 500);
    };
    __decorate([
        Prop({
            default: [],
            type: Array
        })
    ], PurOrderTable.prototype, "listData", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], PurOrderTable.prototype, "isDelivery", void 0);
    __decorate([
        Prop({
            default: '1',
            type: String
        })
    ], PurOrderTable.prototype, "status", void 0);
    PurOrderTable = __decorate([
        Component({
            components: {
                BillSubTable: BillSubTable
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus'
            }))
        })
    ], PurOrderTable);
    return PurOrderTable;
}(Vue));
export default PurOrderTable;
